import { getActiveParkingId } from "../../utils/tenant";
import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs, onSnapshot } from "firebase/firestore";
import { FiClock, FiCheckCircle, FiXCircle, FiInfo } from "react-icons/fi";

export default function MyAttendance() {
    const [employeeData, setEmployeeData] = useState(null);
    const [myAttendance, setMyAttendance] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const db = getFirestore();
    const auth = getAuth();

    useEffect(() => {
        const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
            if (user) {
                try {
                    const q = query(collection(db, "parkings", getActiveParkingId(), "employees"), where("email", "==", user.email));
                    const querySnapshot = await getDocs(q);
                    if (!querySnapshot.empty) {
                        setEmployeeData({ id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() });
                    }
                } catch (error) { console.error("Алдаа:", error); } 
                finally { setIsLoading(false); }
            } else { setIsLoading(false); }
        });
        return () => unsubscribeAuth();
    }, [db, auth]);

    useEffect(() => {
        if (!employeeData) return;
        const qAtt = query(collection(db, "parkings", getActiveParkingId(), "daily_attendance"), where("emp_id", "==", employeeData.emp_id));
        const unsubAtt = onSnapshot(qAtt, (snapshot) => {
            const logs = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            logs.sort((a, b) => new Date(b.date) - new Date(a.date));
            setMyAttendance(logs.slice(0, 30));
        });
        return () => unsubAtt();
    }, [db, employeeData]);

    const formatTimeOnly = (t) => {
        if(!t) return "-";
        return (t.toDate ? t.toDate() : new Date(t)).toLocaleTimeString('mn-MN', { hour: '2-digit', minute: '2-digit' });
    };

    if (isLoading) return <div className="tw-flex tw-justify-center tw-items-center tw-h-screen tw-bg-slate-50 tw-text-blue-600 tw-font-bold">Уншиж байна...</div>;
    if (!employeeData) return <div className="tw-p-10 tw-text-center tw-bg-slate-50 tw-min-h-screen tw-font-bold">Бүртгэл олдсонгүй</div>;

    return (
        // ⭐️ ЭНД АРЫН ӨНГӨ БОЛОН ӨНДРИЙГ НЭМСЭН
        <div className="tw-bg-slate-50 tw-min-h-screen tw-p-4 sm:tw-p-6 lg:tw-p-8 tw-font-sans tw-text-slate-800">
            <div className="tw-max-w-5xl tw-mx-auto">
                <div className="tw-bg-white tw-rounded-3xl tw-shadow-sm tw-border tw-border-slate-200 tw-overflow-hidden tw-animate-fade-in-up">
                    <div className="tw-px-6 tw-py-5 tw-border-b tw-border-slate-100 tw-bg-slate-50/50 tw-flex tw-items-center tw-gap-2">
                        <FiClock className="tw-text-blue-600" size={20} />
                        <div>
                            <h3 className="tw-text-base tw-font-black tw-text-slate-800 tw-m-0">Ирцийн түүх</h3>
                            <p className="tw-text-[11px] tw-text-slate-500 tw-m-0 tw-mt-0.5">Таны сүүлийн 30 хоногийн цагийн мэдээлэл</p>
                        </div>
                    </div>
                    <div className="tw-overflow-x-auto">
                        <table className="tw-w-full tw-text-left tw-border-collapse min-w-[500px]">
                            <thead className="tw-bg-slate-50 tw-border-b tw-border-slate-100">
                                <tr>
                                    <th className="tw-px-6 tw-py-4 tw-text-[11px] tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-widest">Огноо</th>
                                    <th className="tw-px-6 tw-py-4 tw-text-[11px] tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-widest tw-text-center">Ирсэн</th>
                                    <th className="tw-px-6 tw-py-4 tw-text-[11px] tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-widest tw-text-center">Гарсан</th>
                                    <th className="tw-px-6 tw-py-4 tw-text-[11px] tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-widest tw-text-center">Төлөв</th>
                                </tr>
                            </thead>
                            <tbody className="tw-divide-y tw-divide-slate-100">
                                {myAttendance.length === 0 ? (
                                    <tr><td colSpan={4} className="tw-py-12 tw-text-center tw-text-slate-400 tw-text-sm">Ирцийн мэдээлэл байхгүй байна.</td></tr>
                                ) : myAttendance.map((log) => (
                                    <tr key={log.id} className="hover:tw-bg-slate-50/50">
                                        <td className="tw-px-6 tw-py-4 tw-font-bold tw-text-slate-700 tw-text-sm">{log.date}</td>
                                        <td className="tw-px-6 tw-py-4 tw-text-center tw-font-bold tw-text-emerald-600">{formatTimeOnly(log.first_in)}</td>
                                        <td className="tw-px-6 tw-py-4 tw-text-center tw-font-bold tw-text-rose-600">{formatTimeOnly(log.last_out)}</td>
                                        <td className="tw-px-6 tw-py-4 tw-text-center">
                                            {log.status === 'ontime' && <span className="tw-bg-emerald-100 tw-text-emerald-700 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-[11px] tw-font-bold">Хэвийн</span>}
                                            {log.status === 'late' && <span className="tw-bg-amber-100 tw-text-amber-700 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-[11px] tw-font-bold">Хоцорсон</span>}
                                            {log.status === 'absent' && <span className="tw-bg-rose-100 tw-text-rose-700 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-[11px] tw-font-bold">Тасалсан</span>}
                                            {['leave', 'annual_leave', 'business_trip', 'sick'].includes(log.status) && <span className="tw-bg-blue-100 tw-text-blue-700 tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-[11px] tw-font-bold">Чөлөө/Бусад</span>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}